import { ClientConfig, HttpClient } from '../../http';

export const setupAuthEndpoints = (client: HttpClient) => {
  return {
    authorize: (configs?: ClientConfig) => {
      return client.get<void, string>(`/b/admin/authorize`, configs);
    }
  };
};
